/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { format as formatDate } from 'my-phorest/utils/local-date-helpers';
import { service } from '@ember/service';

export default class MessagesListComponent extends Component {
  @service intl;

  get messagesWithSeparators() {
    const chatMessages = this.args.chatMessages || [];
    const itemsWithSeparators = [];

    for (let i = chatMessages.length - 1; i >= 0; i--) {
      const currentMessage = chatMessages[i].message;
      const nextMessage =
        i < chatMessages.length - 1 ? chatMessages[i + 1].message : null;

      if (
        i === chatMessages.length - 1 ||
        (nextMessage &&
          this.#isDifferentDay(
            currentMessage.sentDateTime,
            nextMessage.sentDateTime
          ))
      ) {
        itemsWithSeparators.push({
          type: 'separator',
          date: this.#getDisplayDate(currentMessage.sentDateTime),
        });
      }

      itemsWithSeparators.push(chatMessages[i]);
    }

    return itemsWithSeparators.reverse();
  }

  #isDifferentDay(date1, date2) {
    return new Date(date1).toDateString() !== new Date(date2).toDateString();
  }

  #getDisplayDate(date) {
    const currentDate = new Date(date);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (currentDate.toDateString() === today.toDateString()) {
      return this.intl.t('global.today');
    } else if (currentDate.toDateString() === yesterday.toDateString()) {
      return this.intl.t('global.yesterday');
    } else {
      return formatDate(date, this.intl, 'short');
    }
  }
}
